<template>
    <div class="loading-overlay" :class="{ hidden: !display }" aria-live="polite" aria-atomic="true" role="status" :aria-label="display ? 'Loading content, please wait' : ''">
        <div class="loading-overlay-loader" aria-hidden="true">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "LoadingOverlay",
    props: {
        display: Boolean,
    },
});
</script>

<style></style>
